import {Button} from "@material-ui/core";
import React from "react";
import {GridForm, Grid as GridResponseType} from "ts/api/task";
import {GridTaskLike} from "ts/api/grid-task-like";
import Grid, {
  GridProps,
} from "view/components/GridResponseBlock/CustomizeTable/Components/Grid";
import FlexBox from "view/components/Layout/FlexBox";
import LaunchIcon from "@material-ui/icons/Launch";
import {useCurrentShowId} from "hooks";
import {useForm} from "react-hook-form";
import Form from "view/components/Form";
import {useLocation} from "react-router-dom";
import {EMAIL_TASK_REVIEW_PATH} from "view/routes";
import useOpenGrid from "tools/openGrid";
import {T} from "@tolgee/react";

type GridResponseProps = Pick<GridProps, "headCellSize"> & {
  response: GridResponseType | undefined;
  task: GridTaskLike;
  /** task_responses.id of the shown version — drives the "Open Grid" window. */
  responseId?: string;
};

function GridResponse({
  response,
  task,
  headCellSize,
  responseId,
}: GridResponseProps) {
  const location = useLocation();
  const showId = useCurrentShowId();
  const openGrid = useOpenGrid(showId);

  const isResponseGrid = Array.isArray(response);

  const grid = !isResponseGrid
    ? []
    : response?.map((row) => ({
        cells: row.cells.map((cell) =>
          cell?.type === "text" && cell.text === ""
            ? {...cell, text: " "}
            : cell
        ),
      }));

  // Added-row labels live on the answer rows' `name` (rows beyond the
  // schema). Derive them in add-order; fall back to
  // `task.additionalRowNames`.
  const schemaRowCount = task?.gridSchema?.rows?.length ?? 0;
  const derivedRowNames =
    isResponseGrid && response
      ? response
          .slice(schemaRowCount)
          .map((r) => (r as {name?: string}).name ?? "")
      : undefined;
  const additionalRowNames =
    derivedRowNames && derivedRowNames.some(Boolean)
      ? derivedRowNames
      : task?.additionalRowNames;

  const form = useForm<GridForm>({
    defaultValues: {grid, additionalRowNames},
  });

  if (!isResponseGrid) {
    return <>{response}</>;
  }

  const is3rdParty = location.pathname.includes(EMAIL_TASK_REVIEW_PATH);

  return (
    <FlexBox column gap={4}>
      <Form
        style={{padding: 0, background: "inherit"}}
        form={form}
        onSubmit={form.handleSubmit(() => null)}
      >
        <Grid
          viewOnly
          includeRowTitles={task.gridSchema?.includeRowTitles}
          isResponseMode
          task={task}
          headCellSize={headCellSize}
        />
      </Form>
      {!is3rdParty && !!responseId && (
        <FlexBox alignCenter justifyContent="flex-end">
          <Button
            color="primary"
            onClick={() => openGrid(responseId)}
            endIcon={<LaunchIcon />}
          >
            <T keyName="common.tasks.grid.open" />
          </Button>
        </FlexBox>
      )}
    </FlexBox>
  );
}

export default GridResponse;
